import React from 'react';
import PropTypes from 'prop-types';

const Error = ({ text }) => (
  <div
    className="loading"
    style={{
      width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'inherit', color: 'inherit', padding: '10px',
    }}
  >
    {text}
  </div>
);

Error.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Error;
